module.exports = __webpack_public_path__ + "static/media/pk_180_serv.c8b58eb3.jpg";